<template>
  <div>
   <CRow>
      <CCol>

        <CTableWrapper
          :items=ordersLedger
          :fields=this.fields
          :items-per-page=100
          
          hover
          striped
          bordered
          small
          fixed
          sorter
          approve
          caption = "Lagerliste"
        />
        
        <!--
        <CBadge v-if="cartDiff" id="badgeShipingFee" style="display:block;padding: 1em; margin-bottom:1em;" color="warning">Bestellwert: {{cartSum}} €. Bestellen Sie noch für {{cartDiff}} € um versandkostenfrei zu sein.</CBadge>
        <CBadge v-else id="badgeShipingFee" style="display:block;padding: 1em; margin-bottom:1em;" color="success">Bestellwert: {{cartSum}} €. Sie bestellen versandkostenfrei!.</CBadge>
        -->
        <button type="button" class="btn btn-success" @click="onReOrderAll">Alles Auffüllen</button>
        
        
          
      </CCol>
    </CRow>
 
  </div>
  
</template>
<script>
  import CTableWrapper from './Table.vue'
  import { mapGetters, mapActions } from "vuex";

  export default {
    name: 'Ladger',
    components: { CTableWrapper },
    
    
    data() {
      return {
      
        fields:  [
          {key:'articleno',label:'Artikel',sorter:true},
          {key:'amount',label:'Ist-Menge',sorter:true},
          {key:'target-amount',label:'Soll-Menge',sorter:true},
          {key:'functions',label:'',sorter:false}
        ]        

      };
    },
    computed : mapGetters(["ordersLedger","cartSum","cartDiff","profile"]),
    created() {
      var id;
      if (this.profile.parent > 0 ) {
        id = this.profile.parent;
      } else {
        id = this.profile.id;
      }
      this.getOrdersLedger( {orderUserID:id} ); 
     
    },
    methods: {
      ...mapActions(['getOrdersLedger','ordersLedgerRefillAll']),
      
      onReOrderAll() {

        if (confirm('Möchten Sie wirklich alle Produkte unter der Soll-Menge in den Warenkorb übergeben?')) {
          this.ordersLedgerRefillAll();
        }  

      }

    }
  }
</script>
